var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { position: "relative" } }, [
    _c("div", {
      staticClass: "overlay",
      on: {
        click: function($event) {
          return _vm.$emit("close")
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "modal-content modal-content-responsive" }, [
      _c(
        "button",
        {
          staticClass: "close-popup",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: { "font-size": "30px", color: "#d82d14" },
              attrs: { "aria-hidden": "true" }
            },
            [_vm._v("×")]
          )
        ]
      ),
      _vm._v(" "),
      _c("img", {
        staticClass: "gcic-logo",
        attrs: { src: require("../assets/gcicLogo.png") }
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "modal-text-content modal-text-content-responsive",
          staticStyle: { "padding-bottom": "0px" }
        },
        [
          _vm._v(
            "\n      Welcome to the GCIC investor database, built in collaboration with\n      AlliedCrowds.\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "modal-text-content modal-text-content-responsive",
          staticStyle: { "padding-top": "0px", "padding-bottom": "80px" }
        },
        [
          _vm._v(
            "\n      We have gathered public information about your company, where available,\n      and we’re asking you to fill in any missing gaps. This information will\n      be publicly available, allowing entrepreneurs in Ghana to get a better\n      understanding of what funding options are available to them. If you have\n      any questions, please reach out to: _.\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-create btn-continue btn-save",
          staticStyle: { margin: "auto", display: "block" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_vm._v("\n      Continue\n    ")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            float: "right",
            "padding-top": "50px",
            "padding-right": "50px",
            "margin-top": "16px",
            "margin-bottom": "30px"
          }
        },
        [
          _vm._v("\n      In collaboration with"),
          _c("logo", { attrs: { linked: false } })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cdee0d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cdee0d7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/gcicPopup.vue
// module id = 213
// module chunks = 0